function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickTips = function SvgQuickTips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 289.5 321.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M61.5 77h122v12h-122zM61.5 131h122v12h-122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v250h118a81.58 81.58 0 0 1 11.08-65H61.5v-12h89.27A81.48 81.48 0 0 1 232 163.81V12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 262V12h220v151.81a80.94 80.94 0 0 1 12 4.58V0H0v274h134a80.61 80.61 0 0 1-4-12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 185v12h79.56a81.29 81.29 0 0 1 9.71-12ZM210 321.5a79.5 79.5 0 1 1 79.5-79.5 79.59 79.59 0 0 1-79.5 79.5Zm0-147a67.5 67.5 0 1 0 67.5 67.5 67.58 67.58 0 0 0-67.5-67.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74 262.87q.07-9.36 2.16-13.38t9.3-10.11a59.3 59.3 0 0 0 8.11-9.52 17.84 17.84 0 0 0 3-10.05q0-6.34-3.43-9.85t-9.79-3.5a14.47 14.47 0 0 0-9.23 3q-3.8 3-3.79 8.8h-15.31l-.19-.39q-.19-11.65 7.82-18.17t20.71-6.51q13.76 0 21.44 7t7.69 19.44a27 27 0 0 1-4.81 15.37 60 60 0 0 1-12.14 13q-3.74 3.27-4.68 6.21a29.64 29.64 0 0 0-.95 8.64Zm16.17 27h-16.23v-15.28h16.23Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgQuickTips;